import { render } from "./Zahlungsverkehr.pug?vue&type=template&id=337ee6d9&lang=pug"
import script from "./Zahlungsverkehr.js?vue&type=script&lang=js"
export * from "./Zahlungsverkehr.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__